<div class="min-h-screen flex flex-col">
  <div class="flex-1">
    <router-outlet />
  </div>

  @if (showAppFooter()) {
    <footer
      class="w-full border-t border-textbox-border bg-surface-background"
    >
      <div
        class="mx-auto flex w-[95%] max-w-[1800px] flex-col gap-3 px-4 py-5 text-center text-[13px] text-support-text sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:text-left"
      >
        <div
          class="inter-400 flex items-center justify-center gap-2 sm:justify-start"
        >
          <app-logo
            class="h-7 w-7 rounded-[8px] border border-brand-lavender-border bg-brand-ink p-1 text-brand-lavender"
            [clickable]="false"
          ></app-logo>
          <span>
            Kekeno Surveys
            @if (inBeta) {
              <span class="text-base-200">Beta v{{ version }}</span>
            }
          </span>
        </div>

        <nav
          class="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 inter-400"
          aria-label="Footer"
        >
          <a
            [routerLink]="['/privacy-policy']"
            class="transition-colors hover:text-kek-purple"
          >
            Privacy Policy
          </a>
          <a
            [routerLink]="['/terms-and-conditions']"
            class="transition-colors hover:text-kek-purple"
          >
            Terms of Service
          </a>
          <a
            href="mailto:support@kekeno.tech"
            class="transition-colors hover:text-kek-purple"
          >
            Contact Support
          </a>
        </nav>
      </div>
    </footer>
  }
</div>
<app-toast />
